'use client';

import { memo, useEffect, useState } from 'react';

import { useRouter } from 'next/navigation';

import { resetStore } from '@app/actions/resetStore';
import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch } from '@shared/hooks/redux';
import { WithNeedUpdateTokenProps } from '@shared/types/global';
import { PageLoader } from '@shared/ui/PageLoader';
import { showToast } from '@shared/utils/showToast/showToast';
import { refreshAccessToken } from '@widgets/Auth/api/refreshAccessToken/refreshAccessToken';

type RefreshTokenStateProps = { redirect?: boolean; withoutLoader?: boolean } & WithNeedUpdateTokenProps;

export const RefreshTokenState = memo<RefreshTokenStateProps>(
  ({ redirect = true, withoutLoader = false, needUpdateToken }) => {
    const dispatch = useAppDispatch();

    const [loading, setLoading] = useState(needUpdateToken);

    const { replace, refresh } = useRouter();

    useEffect(() => {
      const updateToken = async () => {
        if (!needUpdateToken) {
          setLoading(false);
          return;
        }

        const { ok } = await refreshAccessToken();

        setLoading(false);

        if (ok) {
          refresh();
          return;
        }

        if (redirect) {
          dispatch(resetStore());
          showToast('Пользователь не авторизован');
          replace(ROUTES.MAIN);
        }
      };

      updateToken();
    }, [dispatch, needUpdateToken, redirect, refresh, replace]);

    return loading && !withoutLoader ? <PageLoader /> : null;
  }
);
